import type { RidePoint } from "../types/ride";
import { useUnits, formatDistance, formatSpeed, formatTemp } from "../lib/units";

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-xs text-slate-500 dark:text-night-400">{label}</div>
      <div className="font-medium tabular-nums text-slate-900 dark:text-night-50">{value}</div>
    </div>
  );
}

export function StatsReadout({ point }: { point: RidePoint | undefined }) {
  const { system } = useUnits();
  if (!point) return null;

  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-3 rounded-xl border border-slate-200 bg-white p-4 sm:grid-cols-3 lg:grid-cols-5 dark:border-night-800 dark:bg-night-900">
      <Field label="Speed" value={formatSpeed(point.speed, system)} />
      <Field label="Battery" value={point.battery !== null ? `${point.battery.toFixed(0)}%` : "–"} />
      <Field label="Voltage" value={`${point.voltage.toFixed(1)} V`} />
      <Field label="Power" value={`${point.power.toFixed(0)} W`} />
      <Field label="Motor current" value={`${point.currentMotor.toFixed(1)} A`} />
      <Field label="Battery current" value={`${point.currentIn.toFixed(1)} A`} />
      <Field label="Duty cycle" value={`${(point.dutyCycle * 100).toFixed(0)}%`} />
      <Field label="Motor temp" value={formatTemp(point.tempMotor, system)} />
      <Field label="MOSFET temp" value={formatTemp(point.tempMosfet, system)} />
      <Field label="Distance" value={formatDistance(point.distanceM, system)} />
      {point.ele !== null && <Field label="Elevation" value={formatDistance(point.ele, system)} />}
      {point.fault !== 0 && <Field label="Fault code" value={String(point.fault)} />}
    </div>
  );
}
